import { render, staticRenderFns } from "./BaseTabs3.vue?vue&type=template&id=7fc5c500&scoped=true&lang=pug&"
import script from "./BaseTabs3.vue?vue&type=script&lang=js&"
export * from "./BaseTabs3.vue?vue&type=script&lang=js&"
import style0 from "./BaseTabs3.vue?vue&type=style&index=0&id=7fc5c500&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc5c500",
  null
  
)

export default component.exports